import { useLocation } from "react-router-dom";

const MainSortTutorLink = () => {
  const { pathname } = useLocation();

  const getAdditionalClass = (pathname) => {
    if (pathname.includes("/inventory")) {
      return "inventory";
    } else if (pathname.includes("/marketplace")) {
      return "marketplace";
    } else {
      return "buypacks";
    }
  };

  if (
    pathname.includes("/marketplace") ||
    pathname.includes("/inventory") ||
    pathname.includes("/buypacks")
  ) {
    return (
      <>
        <button
          className={`gradient-block__search-tutor
            gradient-block__search-tutor--${getAdditionalClass(pathname)}
          `}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-play-btn"
            viewBox="0 0 16 16"
          >
            <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814z" />
            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 0a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
          </svg>
          <p className="craft-block__title-tooltip-text">
            Click to replay tutorial
          </p>
        </button>
      </>
    );
  }
};

export default MainSortTutorLink;
